import {numberFilter} from "../../../admin/script/util/numbers.js";

export class SettingsStorage {

    constructor(namespace, defaults = {}) {
        this.namespace = namespace;
        this.settings = {...defaults};
        this.load();
    }

    store() {
        window.localStorage.setItem(this.namespace, JSON.stringify(this.settings));
        return this;
    }

    load() {
        const raw = window.localStorage.getItem(this.namespace);
        if (raw) {
            this.settings = {
                ...this.settings,
                ...(JSON.parse(raw) || {}),
            };
        }
        return this;
    }

    set(key, value) {
        if (typeof key === "object") {
            for (let field in key) {
                this.settings[field] = key[field];
            }
        } else {
            this.settings[key] = value;
        }
        this.store();
        return this;
    }

    get(key) {
        return this.settings[key];
    }

    getBoolean(key) {
        let value = this.settings[key];
        return value === true || value === 1 || value === '1' || String(value).toLowerCase() === 'true';
    }

    getNumber(key) {
        return numberFilter(this.settings[key]);
    }

}
